import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import { SingleInput, SingleText } from '../../Res/BaseInput';
import { CancelSubmitButton, CancelButton, Space, SearchButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { getUserInfo, getval2Token, getUserInfoCompanyId } from '../../../Login/Auth';
import moment from 'moment';
import { ReqContractorAttendanceSOPCount, ReqContractorAttendance } from '../../../../item/ItemContractorAttendance';
import { api_getContractorAttendanceSOP1Count, api_addContractorAttendance } from '../../../../api/apiContractorAttendancee';
import { WageType1, WageType2, WageType3 } from '../../../../item/ItemCustomerPosition';


export function ContractorAttendanceSOPAddStep2({ id, item, sd, ed, setIsLoading, action }) {
  const [companyId] = useState(getUserInfoCompanyId())
  const [customerContract, setCustomerContract] = useState(null)
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [startEnd, setStartEnd] = useState("")

  const [userInfo] = useState(getUserInfo())

  const [companyName, setCompanyName] = useState("")
  const [signAt, setSignAt] = useState("")

  const [contractorAttendanceSOPName, setContractorAttendanceSOPName] = useState("")
  const [wageTypePeople, setWageTypePeople] = useState("")

  const [salaryMonthlyEnrolment, setSalaryMonthlyEnrolment] = useState(0)
  const [salaryHourlyEnrolment, setSalaryHourlyEnrolment] = useState(0)
  const [bonusEnrolment, setBonusEnrolment] = useState(0)

  
  
  

  const [caseOwner, setCaseOwner] = useState("")
  const [caseOwnerName, setCaseOwnerName] = useState("")


  useEffect(() => {
    //console.log(userInfo)
    setCaseOwner(userInfo.accountId)
    setCaseOwnerName(userInfo.nickName)
  }, [userInfo])


  useEffect(() => {
    if (customerContract !== undefined && item !== customerContract) {
      setCustomerContract(item)
    }
  }, [item])

  useEffect(() => {
    if (startDate !== undefined && sd !== startDate) {
      setStartDate(sd)
    }
  }, [sd])

  useEffect(() => {
    if (endDate !== undefined && ed !== endDate) {
      setEndDate(ed)
    }
  }, [ed])

  useEffect(() => {
    if (customerContract !== undefined && startDate !== "" && endDate !== "") {
      setCompanyName(customerContract.companyName)
      setSignAt(moment(customerContract.signAt).format('YYYY-MM'))
      setStartEnd(startDate + "~" + endDate)
      getCount()
    }
  }, [customerContract, startDate, endDate])

  function getCount() {
    setIsLoading(true)
    var mReqContractorAttendanceSOPCount = new ReqContractorAttendanceSOPCount({
      companyId,
      customerContractId: customerContract.customerContractId,
      startDate,
      endDate
    })
    api_getContractorAttendanceSOP1Count({
      mReqContractorAttendanceSOPCount,
      success: (obj) => {
        // console.log(obj)
        var WageType1 = 0
        var WageType2 = 0
        var WageType3 = 0
        if (obj.count !== undefined) {
          WageType1 = obj.count.WageType1
          WageType2 = obj.count.WageType2
          WageType3 = obj.count.WageType3
          setSalaryMonthlyEnrolment(obj.count.WageType2)
          setSalaryHourlyEnrolment(obj.count.WageType1)
          setBonusEnrolment(obj.count.WageType3)
        }
        setWageTypePeople(<>
          <span className="text-success">月薪 / {WageType2}人</span><br />
          <span className="text-success">時薪 / {WageType1}人</span><br />
          <span className="text-success">代招 / {WageType3}人</span>
        </>)
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        //window.location.replace("/AdminManagerList");
      }
    })
  }

  function toCancel() {
    setCompanyName("")
    action()
  }

  function addAttendance() {
    if (contractorAttendanceSOPName === "") {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: "登錄作業名稱不得為空",
      })
      return
    }
    setIsLoading(true)
    var mReqContractorAttendance = new ReqContractorAttendance({
      companyId,
      contractorAttendanceSOPName,
      customerContractId: customerContract.customerContractId,
      startDate,
      endDate,
      creatId: getUserInfo().accountId
    })
    // console.log(mReqContractorAttendance)
    mReqContractorAttendance.info.salaryMonthly.Enrolment = salaryMonthlyEnrolment
    mReqContractorAttendance.info.salaryHourly.Enrolment = salaryHourlyEnrolment
    mReqContractorAttendance.info.bonus.Enrolment = bonusEnrolment
    mReqContractorAttendance.info = JSON.stringify(mReqContractorAttendance.info)
    // console.log(mReqContractorAttendance)
    api_addContractorAttendance({
      mReqContractorAttendance,
      success: (obj) => {
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: '新增成功',
        }).then(function () {
          window.history.back(-1);
        })
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        //window.location.replace("/AdminManagerList");
      }
    })
  }


  var title = <>
    <span className="text-primary">登錄作業新增 Step 2: </span>
    <span className="text-success">
      {signAt} {companyName}</span>
  </>
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleInput title={"登錄作業名稱"} val={contractorAttendanceSOPName} action={setContractorAttendanceSOPName} placeholder={"松下電機2020年3月份"} size={3} />
          <SingleText title={"作業計算期間"} val={startEnd} />
          <SingleText title={"計薪方式/上工人數"} val={wageTypePeople} />
          <SearchButton name={"新增登錄作業"} action={addAttendance} icon={""} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-2">
            <p>親愛的招募人員請注意</p>
          </div>
          <div className="col-md-10">
            <strong>1. xxxx <p></p>
                      2.xxxx<p></p>

            </strong>
          </div>
        </div>
      </div>
    </>
  var footer =
    <div className="row text-right ">
      <div className="col-sm-12">
        <CancelButton action={toCancel} isRight={true} />
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} titleSize={6} content={content} footer={footer} hasDrawer={false} />
    </>
  )
}

